import styled from 'styled-components'

interface IDisclaimerText {
  themeColor?: string
  padding?: string
}

const DisclaimerText = styled.div<IDisclaimerText>`
  font-weight: ${props => props.theme.fonts.weights.medium};
  font-size: ${props => props.theme.fonts.sizes[12]};
  color: ${props =>
    props.themeColor ? props.theme.colors[props.themeColor] : props.theme.colors.neutral400};
  ${props => (props.padding ? `padding: ${props.padding};` : '')}
`

export default DisclaimerText
